import { z } from "zod";
const attributesStepSchema = z.object({
  id: z.string(),
  icon: z.string().optional(),
  title: z.string().optional(),
  childIndex: z.number().optional(),
  interactivity: z.string().optional()
});
const attributesStepsSchema = z.object({
  children: z.array(attributesStepSchema)
});
export {
  attributesStepSchema,
  attributesStepsSchema
};
//# sourceMappingURL=attributes.js.map
